import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "../api.js";
import { ErrorBox, SuccessBox, fmtDate } from "../components/helpers.jsx";

export default function HwidBanDetail() {
    const { subject } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);
    const [msg, setMsg] = useState(null);
    const [reload, setReload] = useState(0);

    useEffect(() => {
        let alive = true;
        api.get(`/api/admin/hwid-bans/${encodeURIComponent(subject)}`)
            .then((d) => { if (alive) setData(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [subject, reload]);

    async function removeAll() {
        if (!confirm(`Remove every HWID-ban row for ${subject}? The subject ban itself stays.`)) return;
        try {
            await api.del(`/api/admin/hwid-bans/${encodeURIComponent(subject)}`);
            navigate("/hwid-bans", { replace: true });
        } catch (e) { setErr(e.message); }
    }

    async function removeRow(id) {
        try {
            await api.del(`/api/admin/hwid-bans/row/${id}`);
            setMsg(`Row #${id} removed.`);
            setReload(Date.now());
        } catch (e) { setErr(e.message); }
    }

    return (
        <>
            <div className="page-header">
                <div>
                    <h1 className="mono">{subject}</h1>
                    <div className="sub"><Link to="/hwid-bans">← all HWID bans</Link></div>
                </div>
                <button className="danger" onClick={removeAll}>Remove all rows</button>
            </div>

            <ErrorBox>{err}</ErrorBox>
            <SuccessBox>{msg}</SuccessBox>

            {data && (
                <>
                    <div className="card">
                        <h2>Weights &amp; threshold</h2>
                        <div className="row text-dim">
                            <div>Threshold: <span className="mono" style={{ color: "var(--text)" }}>{data.threshold}</span></div>
                            <div>Sum of any single subject's weights ≥ threshold → ban.</div>
                        </div>
                    </div>

                    <div className="table-wrap">
                        <table className="data">
                            <thead>
                                <tr>
                                    <th>Kind</th>
                                    <th>Value</th>
                                    <th>Weight</th>
                                    <th>Banned at</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.rows.length === 0 && (
                                    <tr><td colSpan={5} className="text-dim" style={{ padding: 24, textAlign: "center" }}>
                                        No rows
                                    </td></tr>
                                )}
                                {data.rows.map((r) => (
                                    <tr key={r.id}>
                                        <td>{r.kind}</td>
                                        <td className="mono">{r.value}</td>
                                        <td className="mono">{data.weights[r.kind] ?? "0"}</td>
                                        <td>{fmtDate(r.bannedAt)}</td>
                                        <td><button className="ghost" onClick={() => removeRow(r.id)}>remove</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    );
}
